/* assets/src/viewer/index.js — FASE 6 entry/bootstrap del Viewer 3D. */
import { Viewer } from './core/viewer.js';
import { buildProceduralTextureLibrary } from './materials/textures.js';
import { MaterialLibrary } from './materials/library.js';
import { PergolaController } from './models/controller.js';
import { OptionalEffects } from './effects/optional.js';
import { Hotspots } from './interaction/hotspots.js';
import { FurnitureManager } from './furniture/manager.js';
import { installContract } from './contract/globals.js';

let viewer = null;

function boot() {
  const container = document.getElementById('asg-3d-canvas');
  if (!container) return;
  try {
    viewer = new Viewer(container);

    const textures = buildProceduralTextureLibrary(viewer.renderer);
    const materials = new MaterialLibrary(textures);
    viewer.materials = materials;
    viewer.controller = new PergolaController(viewer, materials);

    // Optional -> 3D, hotspot raycasting, qualità adattiva.
    const effects = new OptionalEffects(viewer);
    viewer.controller.onEffects = (cfgRaw, model, dims) => effects.apply(cfgRaw, model, dims);
    viewer.hotspots = new Hotspots(viewer);
    viewer.furniture = new FurnitureManager(viewer);

    // Il render loop deve avanzare anche i cross-fade colore dei materiali.
    const baseStep = viewer.stepAnimations.bind(viewer);
    viewer.stepAnimations = (t) => {
      const a = baseStep(t);
      const b = materials.update(performance.now());
      return a || b;
    };

    window.__ASG_VIEWER = viewer;
    installContract(viewer);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[ASG Viewer F6] inizializzazione fallita:', e);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

export { viewer };
